import input from '@/components/input'

/**
 * @module
 * @name InputText
 * @extends Input
 */
export default {
  name: 'InputText',
  extends: input,
  data: function () {
    return {
      inputHasFocus: false
    }
  },

  /**
   * @property {String} icon VueSVGicon
   * @property {String} placeholder Placeholder to show while input is empty.
   * @property {String} type Text input could also be of type number, password.
   * @property {Boolean} removeIcon If true, shows X to delete input content.
   */
  props: {
    icon: {
      type: String,
      required: false
    },
    placeholder: {
      type: String | Number,
      required: false
    },
    type: {
      type: String,
      required: false,
      validator: (v) => ['text', 'password', 'number'].indexOf(v) !== -1,
      default: 'text'
    },
    removeIcon: {
      type: Boolean,
      required: false,
      default: false
    },
    inputError: {
      type: Boolean | Number,
      required: false
    },
    inputTextError: {
      type: String,
      required: false
    },
    placeHolderInput: {
      type: String | Number,
      required: false
    }
  },

  /**
   * @property {Boolean} showRemoveIcon  Returns if removeIcon should be showed.
   */
  computed: {
    showRemoveIcon: function () {
      return this.removeIcon && this.value && this.value.length > 0
    }
  },
  methods: {
    numericInput() {
      if (this.type === 'number') {
        const nodeList = document.querySelector('.inputText')
        nodeList.setAttribute('inputmode', 'numeric')
      }
    }
  },
  mounted() {
    this.numericInput()
  }
}
